// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"223":"e21ba57872550241","333":"a804858492f538f1"}[chunkId] + ".css";
};